import React, { useMemo } from 'react';
import AssistantAvatar from '../AssistantAvatar';
import BotMessage from '../BotMessage';
import UserMessage from '../UserMessage';
import TypingLoader from '../TypingLoader';
import { useAssistantState } from '../../hooks/useLottoAssistantContext';
import classes from './ChatContainer.module.scss';

const ChatContainer = React.memo(({ messagesEndRef, onScrollToLastMessage }) => {
  const { messages, isSendingMessage } = useAssistantState();

  const renderedMessages = useMemo(
    () =>
      messages.map((message) =>
        message.type === 'user' ? (
          <UserMessage key={message.id} message={message} />
        ) : (
          <BotMessage
            key={message.id}
            message={message}
            onScrollToLastMessage={onScrollToLastMessage}
          />
        )
      ),
    [messages, onScrollToLastMessage]
  );

  return (
    <div className={classes.MainWrapper}>
      <div className={classes.Header}>
        <AssistantAvatar />
        <div className={classes.HeaderTextWrapper}>
          <p className={classes.HeaderTitle}>Lottery Betting Assistant</p>
          <div className={classes.HeaderStatusRow}>
            <span className={classes.OnlineIndicator} />
            <span className={classes.HeaderSubtitle}>Online</span>
          </div>
        </div>
      </div>

      <div id="auto-scroll-container" className={classes.MessagesContainer}>
        {renderedMessages}
        {isSendingMessage && <TypingLoader />}
      </div>

      <div ref={messagesEndRef} />
    </div>
  );
});

ChatContainer.displayName = 'ChatContainer';

export default ChatContainer;
